export default from './current-user-profile-link';



// WEBPACK FOOTER //
// ./app/containers/current-user-profile-link/index.js